import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
  Card as MuiCard,
} from '@mui/material';
import { styled } from '@mui/material/styles';

import axios from 'axios';


const REACT_EXPRESS = process.env.REACT_APP_EXPRESS_SERVER;


const OtpLogin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ otp: '' });
  const [errorsObj, setErrors] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors('');
    
    const cleanedFormData = {
      username: location.state?.uname || '',
      password: location.state?.pwd || '',
      sentOtp: formData.otp,
    };

    try {
      const response = await axios.post(`${REACT_EXPRESS}/loginWithOtp`, cleanedFormData);
      const { token, validity, userFirstLogin, isAdmin} = response.data.data;

      //Console.log(userFirstLogin);
      
      if (validity === 'Found' && token) {
        // localStorage.setItem('authToken', token);
        sessionStorage.setItem('isAdmin', isAdmin == null ? '' : String(isAdmin));
        sessionStorage.setItem('authToken', JSON.stringify(token));
        // console.log('Token saved:', token); // Debug log
      
        // Notify App.js that the token has been updated
        window.dispatchEvent(new Event('tokenUpdated'));
      
        if (userFirstLogin) {
          navigate('/changepwd',{ state: { email: cleanedFormData.username || location.state?.uname } });
        } else {
          navigate('/home');
        }
      } else {
        setErrors(validity || 'Invalid OTP');
      }
    } catch (error) {
      setErrors('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const Card = styled(MuiCard)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    margin: 'auto',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '450px',
    },
    boxShadow:
      'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
    ...theme.applyStyles('dark', {
      boxShadow:
        'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
    }),
  }));

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '80vh',
        width: '60%'
      }}
    >
      <Card>
        <Typography
          variant="h4"
          sx={{
            marginBottom: 2,
            fontSize: 'clamp(1rem, 5vw, 1.1rem)',
            textAlign: 'center',
          }}
        >
          Enter OTP to Login
        </Typography>
        <Typography variant="body2" sx={{ textAlign: 'center', marginBottom: 2 }}>
          Provide the OTP sent to your email.
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <TextField
            name="otp"
            type="text"
            label="OTP"
            placeholder=""
            value={formData.otp}
            onChange={handleChange}
            autoFocus
            required
            fullWidth
            size="small"
            error={!!errorsObj}
            helperText={errorsObj || ''}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ padding: 1, fontSize: '0.875rem' }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit'}
          </Button>
        </Box>
      </Card>
    </Box>
  );
};

export default OtpLogin;
